// Auto-Pause Rules API Client (S010)
import { apiClient } from './apiClient';
import type { AutoPauseRule, AutoPauseRuleCreate, AutoPauseRuleUpdate, AutoPauseExecution } from '../types/auto-pause';

export const autoPauseApi = {
  // List all rules
  async list(): Promise<AutoPauseRule[]> {
    const response = await apiClient.get('auto-pause-rules');
    return response.data.rules;
  },

  // Get single rule
  async get(id: string): Promise<AutoPauseRule> {
    const response = await apiClient.get(`auto-pause-rules/${id}`);
    return response.data;
  },

  // Create rule
  async create(data: AutoPauseRuleCreate): Promise<AutoPauseRule> {
    const response = await apiClient.post('auto-pause-rules', data);
    return response.data;
  },

  // Update rule
  async update(id: string, data: Partial<AutoPauseRuleCreate>): Promise<AutoPauseRule> {
    const response = await apiClient.put(`auto-pause-rules/${id}`, data);
    return response.data;
  },

  // Delete rule
  async delete(id: string): Promise<void> {
    await apiClient.delete(`auto-pause-rules/${id}`);
  },

  // Toggle rule active status
  async toggle(id: string, isActive: boolean): Promise<AutoPauseRule> {
    const response = await apiClient.patch(`auto-pause-rules/${id}/toggle`, {
      is_active: isActive,
    });
    return response.data;
  },

  // Get rule execution history
  async getExecutions(ruleId: string): Promise<AutoPauseExecution[]> {
    const response = await apiClient.get(`auto-pause-rules/${ruleId}/executions`);
    return response.data.executions;
  },

  // Test rule (dry run)
  async test(ruleId: string): Promise<{ campaigns_affected: number; details: any[] }> {
    const response = await apiClient.post(`auto-pause-rules/${ruleId}/test`);
    return response.data;
  },
};
